import { render } from "./OrderAdditionalCharges.vue?vue&type=template&id=6051f8ce"
import script from "./OrderAdditionalCharges.vue?vue&type=script&lang=js"
export * from "./OrderAdditionalCharges.vue?vue&type=script&lang=js"
script.render = render

export default script